import axios from 'axios';
import { MasterDataURL } from '../../../../config/UrlEndPoint';

export const URL = `${MasterDataURL}access_role`;

export function getMaterAccessRole() {
    return axios.get(`${URL}/master_role`);
}

// Get AccessRole All For use Combobox data
export function getAccessRoleAll() {
    return axios.get(URL);
}

// //Get By ID
export function getAccessRoleById(accessRoleId) {
    return axios.get(`${URL}/${accessRoleId}`);
}

// items => filtered/sorted result for table data
export function findAccessRole(queryParams) {
    return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the accessRole on the server
export function createAccessRole(accessRole) {
    return axios.post(URL, accessRole);
}

// UPDATE => PUT: update the accessRole on the server
export function updateAccessRole(accessRole) {
    return axios.put(`${URL}/${accessRole.uuid}`, accessRole);
}

// UPDATE => Delete: Delete the accessRole on the server
export function deleteAccessRole(accessRole) {
    return axios.delete(`${URL}/${accessRole.uuid}`, accessRole);
}


